import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ussdSmsHero from "../assets/Hero/chat-hero.webp"; // Replace with your hero image
import ussdSmsImage from "../assets/Hero/sms.png"; // Replace with your USSD/SMS image
import "../assets/css/ussdAndSmsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const ussdSmsData = {
  hero: {
    title: "USSD, Bulk SMS & ChatBots",
    subtitle: "Enhance Communication with Advanced Messaging Solutions",
  },
  introduction: {
    heading: "Why USSD, Bulk SMS & ChatBots Matter",
    paragraphs: [
      "USSD, Bulk SMS, and ChatBots are powerful tools for engaging customers, delivering information, and automating communication workflows.",
      "Our solutions are designed to provide seamless, scalable, and cost-effective communication for businesses of all sizes.",
    ],
  },
  cta: {
    heading: "Ready to Transform Your Communication?",
    text: "Contact us today to learn more about our USSD, Bulk SMS, and ChatBot Solutions and how we can help your business thrive.",
  },
};

export const USSDAndSmsPage = ({ data }) => {
  const ussdSmsRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = ussdSmsRef.current.querySelectorAll(".ussd-sms-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: ussdSmsRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="ussd-sms-page" ref={ussdSmsRef}>
      {/* Hero Section */}
      <div
        className="ussd-sms-hero-section"
        style={{ backgroundImage: `url(${ussdSmsHero})` }}
      >
        <h1 className="ussd-sms-animate">{ussdSmsData.hero.title}</h1>
        <p className="ussd-sms-animate">{ussdSmsData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container ussd-sms-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="ussd-sms-animate">{ussdSmsData.introduction.heading}</h2>
            {ussdSmsData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="ussd-sms-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 ussd-sms-image-container">
            <img
              src={ussdSmsImage}
              className="img-fluid ussd-sms-animate"
              alt="USSD, Bulk SMS & ChatBots"
            />
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container ussd-sms-cta">
        <h2 className="ussd-sms-animate">{ussdSmsData.cta.heading}</h2>
        <p className="ussd-sms-animate">{ussdSmsData.cta.text}</p>
        <button
          className="btn btn-primary ussd-sms-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};